// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__flexIt___UnUs6 {
  display: flex;
  flex-direction: row;
}
.styles__description___kyS6c {
  font-size: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  line-height: 1.25;
}
.styles__border____AVjU {
  border: 1px solid #e0e0e0;
  flex: 1 1 auto;
}
.styles__icon___eHEcf {
  z-index: 10;
}
.styles__wrapper___AhtKW {
  display: flex;
  align-items: center;
  flex: 1;
}
.styles__iconWithText____ZskJ {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.styles__text___h8b4i {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
}
.styles__image___AbvlF {
  float: left;
  padding: 4px 15px;
}
.styles__listItem____fg7I {
  padding: 15px 0 15px 20px;
  position: relative;
}
@media (max-width: 768px) {
  .styles__listItem____fg7I {
    width: 100%;
  }
}
.styles__highlight___kQ0Yl {
  background-color: #fff;
}
.styles__first___BQURx {
  padding-left: 0px;
}
.styles__link___Db4Nx {
  width: 100%;
  overflow: hidden;
  color: #7F7F7F !important;
  padding-right: 76px;
}
.styles__title___zY8_T {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 16px;
  margin: 0;
  line-height: 1.25;
}
.styles__last___U2hlR {
  flex: 1 1 auto;
}
.styles__item___jMOEd {
  flex: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/components/WheelProgressItem/styles.less"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;AADF;AAIA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;AAFF;AAKA;EACE,yBAAA;EACA,cAAA;AAHF;AAMA;EACE,WAAA;AAJF;AAOA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;AALF;AAQA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AANF;AASA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AAPF;AAUA;EACE,WAAA;EACA,iBAAA;AARF;AAWA;EAKE,yBAAA;EACA,kBAAA;AAZF;AAQE;EAAA;IACE,WAAA;EALF;AACF;AAUA;EACE,sBAAA;AAPF;AAWA;EACE,iBAAA;AATF;AAYA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAVF;AAaA;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,iBAAA;AAXF;AAcA;EACE,cAAA;AAZF;AAeA;EACE,OAAA;AAbF","sourcesContent":["@import '../../../shared/variables.less';\n\n.flexIt {\n  display: flex;\n  flex-direction: row;\n}\n\n.description {\n  font-size: 12px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  display: block;\n  line-height: 1.25;\n}\n\n.border {\n  border: 1px solid #e0e0e0;\n  flex: 1 1 auto;\n}\n\n.icon {\n  z-index: 10;\n}\n\n.wrapper {\n  display: flex;\n  align-items: center;\n  flex: 1;\n}\n\n.iconWithText {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 12px;\n}\n\n.image {\n  float: left;\n  padding: 4px 15px;\n}\n\n.listItem {\n  composes: flexIt;\n  @media (max-width: @screen-sm-min) {\n    width: 100%;\n  }\n  padding: 15px 0 15px 20px;\n  position: relative;\n}\n\n.highlight {\n  background-color: #fff;\n  composes: listItem;\n}\n\n.first {\n  padding-left: 0px;\n}\n\n.link {\n  width: 100%;\n  overflow: hidden;\n  color: @eon-text-color-muted !important;\n  padding-right: 76px;\n}\n\n.title {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  font-size: 16px;\n  margin: 0;\n  line-height: 1.25;\n}\n\n.last {\n  flex: 1 1 auto;\n}\n\n.item {\n  flex: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexIt": `styles__flexIt___UnUs6`,
	"description": `styles__description___kyS6c`,
	"border": `styles__border____AVjU`,
	"icon": `styles__icon___eHEcf`,
	"wrapper": `styles__wrapper___AhtKW`,
	"iconWithText": `styles__iconWithText____ZskJ`,
	"text": `styles__text___h8b4i`,
	"image": `styles__image___AbvlF`,
	"listItem": `styles__listItem____fg7I styles__flexIt___UnUs6`,
	"highlight": `styles__highlight___kQ0Yl styles__listItem____fg7I styles__flexIt___UnUs6`,
	"first": `styles__first___BQURx`,
	"link": `styles__link___Db4Nx`,
	"title": `styles__title___zY8_T`,
	"last": `styles__last___U2hlR`,
	"item": `styles__item___jMOEd`
};
export default ___CSS_LOADER_EXPORT___;
